import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/ennix-electronics/node_modules/next/dist/client/app-dir/link.js");
